module.exports = __webpack_public_path__ + "static/media/korg-light.c4deda9b.svg";